import { getSessionToken } from "./auth";

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

function getHeaders(headers = {}, body, authenticated) {
  const nextHeaders = { ...headers };
  const token = getSessionToken();

  if (authenticated && token && !nextHeaders.Authorization) {
    nextHeaders.Authorization = `Bearer ${token}`;
  }

  if (!(body instanceof FormData) && !nextHeaders["Content-Type"]) {
    nextHeaders["Content-Type"] = "application/json";
  }

  return nextHeaders;
}

export async function apiRequest(path, options = {}) {
  const {
    authenticated = true,
    body,
    headers,
    parseJson = true,
    ...rest
  } = options;

  const response = await fetch(`${process.env.REACT_APP_API_PATH}${path}`, {
    ...rest,
    headers: getHeaders(headers, body, authenticated),
    body:
      body instanceof FormData || typeof body === "string" || body == null
        ? body
        : JSON.stringify(body),
  });

  if (!parseJson) {
    if (!response.ok) {
      throw new ApiError(response.statusText || "Request failed", response.status);
    }
    return response;
  }

  const text = await response.text();
  const data = text ? JSON.parse(text) : null;

  if (!response.ok) {
    throw new ApiError(
      data?.message || response.statusText || "Request failed",
      response.status,
      data
    );
  }

  return data;
}

export const api = {
  get: (path, options = {}) => apiRequest(path, { ...options, method: "GET" }),
  post: (path, body, options = {}) =>
    apiRequest(path, { ...options, method: "POST", body }),
  patch: (path, body, options = {}) =>
    apiRequest(path, { ...options, method: "PATCH", body }),
  delete: (path, options = {}) =>
    apiRequest(path, { ...options, method: "DELETE" }),
};

export function unwrapCollection(result) {
  return Array.isArray(result?.[0]) ? result[0] : [];
}
